export default __webpack_public_path__ + "static/media/italy.e407516e.svg";